let store = require("../store");
let actions = require("../actions");

let FormControls = mc.widgets.FormControls;
let FormFeedback = mc.widgets.FormFeedback;

let QuestionEditor = require("../widget/QuestionEditor");

class CustomFieldsFormView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      study: mc.utils.clone(props.study),
      errors: [],
      submitting: false
    };
  }

  setFields(fields) {
    let study = mc.utils.clone(this.state.study);

    study.subjectMetadataFields = fields.map(function (field) {
      field.displayName = field.text;
      return field;
    });

    this.setState({ study });
  }

  saveStudy() {
    let study = this.state.study;

    actions.saveStudy(study, "UPDATE").then((function (payload) {
      if (payload.errors.length) {
        this.setState({
          errors: payload.errors,
          submitting: false
        });
      }
      else {
        mc.ui.modal(null);
      }
    }).bind(this));

    this.setState({
      submitting: true
    });
  }

  isValid() {
    let fields = this.state.study.subjectMetadataFields;

    return fields.every(function (field) {
      let name = field.displayName;

      if (!name.trim().length) {
        return false;
      }

      if (fields.filter((f) => f.displayName === name).length > 1) {
        return false;
      }

      if (field.type === "MULTIPLECHOICE") {
        if (field.values.length < 2 || field.values.some((v) => v.trim().length === 0)) {
          return false;
        }
      }

      return true;
    });
  }

  cancel() {
    mc.ui.modal(null);
  }

  static open(study) {
    mc.ui.modal(<CustomFieldsFormView study={study}/>, { width: "600px", dismissable: false });
  }

  render() {
    let questions = this.state.study.subjectMetadataFields.map(function (field) {
      field.text = field.displayName;
      return field;
    });

    return (
      <div>
        <h1>{tx("subject_fields")}</h1>
        <p>{tx("define_subject_fields")}</p>
        <QuestionEditor
          types={["FREETEXT", "NUMERIC", "MULTIPLECHOICE", "BOOLEAN"]}
          labels={[tx("name"), tx("type"), tx("add_field")]}
          fieldSize={20}
          questions={questions}
          questionMaxLength={32}
          onEdit={this.setFields.bind(this)}
          disabled={false}/>
        <FormFeedback errors={this.state.errors}/>
        <FormControls
          onSave={this.saveStudy.bind(this)}
          onCancel={this.cancel.bind(this)}
          enabled={this.isValid() && !this.state.submitting}/>
      </div>
    );
  }
}

module.exports = CustomFieldsFormView;